/**
 * Converts sort string to enmonMeter sorts format
 * Example: "serialNumber:ascend" -> [{ field: "serial", order: "ascend" }]
 */
export const convertSortToEnmonFormat = (sortString?: string) => {
  if (!sortString) return undefined;

  const [columnKey, order] = sortString.split(':');
  if (!columnKey) return undefined;

  return [`${order === 'ascend' ? '' : '-'}${columnKey}`];
};
